import React, { useState } from "react";
import "./JavaFullStack.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { FaHome } from "react-icons/fa";
import { API_URL } from "../config/api";

import {
  FaCode,
  FaServer,
  FaUserTie,
  FaBriefcase,
  FaProjectDiagram,
  FaCertificate,
} from "react-icons/fa";

const JavaFullStack = () => {
  const COURSE_NAME = "Java Full Stack";

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    mode: "",
    level: "",
  });

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    // Name -> only letters and spaces
    if (name === "name") {
      updatedValue = value.replace(/[^A-Za-z\s]/g, "");
    }

    // Email -> convert to lowercase
    if (name === "email") {
      updatedValue = value.toLowerCase();
    }

    // Phone -> only digits and max 10 numbers
    if (name === "phone") {
      updatedValue = value.replace(/\D/g, "").slice(0, 10);
    }

    setFormData({
      ...formData,
      [name]: updatedValue,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setMessage("");
    setError("");

    // Empty field validation
    if (
      !formData.name ||
      !formData.phone ||
      !formData.email ||
      !formData.mode ||
      !formData.level
    ) {
      setError("Please fill all fields");
      setLoading(false);
      return;
    }

    if (!/^[A-Za-z\s]+$/.test(formData.name)) {
      setError("Name should contain only letters");
      setLoading(false);
      return;
    }

    if (!/^\d{10}$/.test(formData.phone)) {
      setError("Phone number must be exactly 10 digits");
      setLoading(false);
      return;
    }

    if (!/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/.test(formData.email)) {
      setError("Enter a valid email address");
      setLoading(false);
      return;
    }

    try {
      const payload = {
        ...formData,
        courseName: COURSE_NAME,
      };

      const res = await axios.post(API_URL, payload);

      console.log("RESPONSE:", res.data);

      if (res.data.success) {
        window.open(res.data.whatsappUrl, "_blank");

        setMessage("Redirecting to WhatsApp...");

        setTimeout(() => {
          setMessage("");
        }, 3000);

        setFormData({
          name: "",
          phone: "",
          email: "",
          mode: "",
          level: "",
        });
      }
    } catch (err) {
      console.error("ERROR:", err);

      setError(
        err.response?.data?.message ||
          "Something went wrong. Please try again.",
      );
    }

    setLoading(false);
  };

  return (
    <div className="java-hero">
      {message && <div className="success-msg">{message}</div>}
      {error && <div className="error-msg">{error}</div>}

      <div className="breadcrumb">
        <Link to="/">
          <FaHome /> Home
        </Link>{" "}
        / <span>Java Full Stack</span>
      </div>

      <div className="overlay">
        <div className="hero-left">
          <span className="badge">AAPS Career</span>

          <h1>
            <span className="white">Java </span>
            <span className="orange">Full Stack </span>
            <span className="white">Course</span>
          </h1>

          <ul className="points">
            <li>Build complete web applications using Frontend & Backend</li>
            <li>Master Java, Spring Boot, and REST APIs</li>
            <li>Develop dynamic UI using HTML, CSS, JavaScript & React</li>
            <li>Hands-on database integration with MySQL</li>
            <li>Work on real-time full stack projects</li>
          </ul>

          <div className="features">
            <div>
              <FaCode /> Frontend Development
            </div>

            <div>
              <FaServer /> Backend APIs
            </div>

            <div>
              <FaUserTie /> Expert Trainers
            </div>

            <div>
              <FaBriefcase /> Placement Support
            </div>

            <div>
              <FaProjectDiagram /> Live Projects
            </div>

            <div>
              <FaCertificate /> Certification
            </div>
          </div>

          <div className="learn">
            <h3>What You Will Learn</h3>

            <div className="tags">
              <span>HTML</span>
              <span>CSS</span>
              <span>JavaScript</span>
              <span>React</span>
              <span>Java</span>
              <span>Spring Boot</span>
              <span>REST APIs</span>
              <span>MySQL</span>
            </div>
          </div>
        </div>

        <div className="hero-right">
          <div className="form-card">
            <h3>Fill Your Details</h3>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                autoComplete="off"
                required
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                maxLength={10}
                autoComplete="off"
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                autoComplete="off"
                required
              />

              <select
                name="mode"
                value={formData.mode}
                onChange={handleChange}
                required
              >
                <option value="">Select Training Type</option>
                <option value="Classroom">Classroom</option>
                <option value="Online">Online</option>
              </select>

              <select
                name="level"
                value={formData.level}
                onChange={handleChange}
                required
              >
                <option value="">I am...</option>

                <option value="Beginner">Beginner</option>

                <option value="Student">Student</option>

                <option value="Working Professional">
                  Working Professional
                </option>
              </select>

              <button type="submit" className="book-btn" disabled={loading}>
                {loading ? "Submitting..." : "Book Now"}
              </button>
            </form>

            <div className="divider">OR</div>

            <a href="tel:+919573470659" className="call-btn">
              Call Now
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JavaFullStack;
